<template>
  <div class="container-fluid">
    <!-- <div class="row mt-5">
      <div class="col-sm-12 mb-3 text-center">
        <h1 class="text-dark">Interview List</h1>
      </div>
    </div> -->
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center">
      <div class="px-3">
        <span>Filters:</span>
      </div>
      <div class="">
        <div class="row justify-content-end px-3">
            <div>
              <label class="pr-3 mb-0">
                <b-input-group class="advance-search-field">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-md SearchInput"
                    @keydown.enter.native="onUpdateFilter"
                  ></b-form-input>
                  <b-input-group-prepend class="btn2 btn2-tertiary">
                    <span 
                      class="input-group-text bg-white" 
                      :class="1 == 2 ? '' : 'right-search-border'" 
                      @click="onUpdateFilter"
                    >
                      <i class="uil-search"></i>
                    </span>
                  </b-input-group-prepend>
                  <!-- <b-input-group-prepend class="btn2 btn2-tertiary" v-if="false">
                    <span class="input-group-text bg-white right-search-border" @click="showAdvanceSeach = !showAdvanceSeach"><i class="uil-sliders-v" style="transform: rotate(270deg);"></i></span>
                  </b-input-group-prepend> -->
                </b-input-group>
                <!-- <b-input-group 
                  v-show="showAdvanceSeach" 
                  class="w-100 px-3 custom-advance-search mt-1 mr-2" 
                >
                  <hrflow-fields-search
                    hasButton
                    ref="advanceSearch"
                    class="w-100"
                    @onSearchField="onSearch"
                  />
                </b-input-group> -->
              </label>
            </div>
            <div style="width: 180px;">
              <multiselect
                ref="Tag"
                autocomplete
                :multiple="true"
                v-model="filterItems"
                :options="tagOptions"
                :searchable="true"
                placeholder="Status"
                :clear-on-select="false"
                :close-on-select="false"
                :show-labels="false"

                track-by="name"
                label="name"
                @input="onInputFilter(filterItems.tag, 'Tag')"
                @remove="onRemoveFilters(filterItems.tag, 'Tag')"
              >
              <template #selection="{ values, search, isOpen }">
                <span class="multiselect__single"
                      v-if="values.length"
                      v-show="!isOpen">{{ values.length }} tag(s) selected
                </span>
              </template>
            </multiselect>
            </div>

          
        </div>

    
      </div>
    </div>
      </div>
    </div>
    <div class="">
      <div class="">
        <DataTable ref="list" />
      </div>
    </div>
  </div>
</template>

<script>
  import DataTable from './components/DataTable.vue'

  export default {
    components: { DataTable },
    data(){
      return{
        filter: '',
        filterItems:null,
        tagOptions: [],
      }
    },
    methods: {
      onUpdateFilter(){

      }
    },
  }
</script>
